// extracted by mini-css-extract-plugin
export default {"link":"ProcessMap_link__yODLZ","linkTitle":"ProcessMap_linkTitle__IYYpP","nonProcess":"ProcessMap_nonProcess__mqs9a"};